import React from 'react';
import { connect } from 'react-redux';
import PortEdit from '../../elements/PortEdit.jsx';
import { handleFormChanged } from '@/store/allaround.store.js';

class PortContainer extends React.Component {
  shouldComponentUpdate(props, state) {
    const newPropsClone = JSON.parse(JSON.stringify(props));
    const oldPropsClone = JSON.parse(JSON.stringify(this.props));
    if (JSON.stringify(state) == JSON.stringify(this.state)
      && JSON.stringify(newPropsClone) == JSON.stringify(oldPropsClone)) {
      return false;
    }
    return true;
  }

  render() {
    return (<div>
      <PortEdit
        loadingPorts={this.props.loadingPorts}
        dischargePorts={this.props.dischargePorts}
        transport={this.props.transport}
        idx={this.props.ordinalId}
        data={this.props.port}
        formId={this.props.idx}
        portType={this.props.portType}
        disabled={this.props.disabled}
      />
    </div>);
  }
}

PortContainer.propTypes = {
  port: React.PropTypes.object,
  portType: React.PropTypes.string,
  idx: React.PropTypes.number,
  disabled: React.PropTypes.bool,
  ordinalId: React.PropTypes.number,
  transport: React.PropTypes.object,
  loadingPorts: React.PropTypes.object,
  dischargePorts: React.PropTypes.object,
};

export default connect(
  (state, props) => ({
    port: state.getIn(['data', 'deals', 'ports', props.portType, props.idx]),
    formChanged: state.getIn(['allaround', 'formChanged']),
  }),
  (dispatch) => ({
    handleFormChanged() {
      handleFormChanged(dispatch);
    },
  }))(PortContainer);
